'use client';

import { Link, ListItem } from '@coolblue-development/freddy';
import navigateTrigger from '@coolblue-development/ga4-events/triggers/SegmentNavigation/navigateTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  url: string;
  urlIndexable: boolean;
  itemIndex: number;
  totalIndices: number;
};

const SegmentNavigationItem = ({ children, url, urlIndexable, itemIndex, totalIndices }: Props) => {
  const nofollow = (urlIndexable: boolean) => (!urlIndexable ? 'nofollow' : undefined);

  const { trackEvent } = useAnalytics();

  const params = {
    sub_feature: 'general_navigation' as const,
    index: itemIndex + 1,
    total_indices: totalIndices,
    url: url,
    redirect: url
  };

  return (
    <ListItem
      py={100}
      pl={400}
      sx={theme => ({
        position: 'relative',
        '&:before': {
          position: 'absolute',
          top: 0,
          left: 0,
          content: '""',
          width: theme.borderWidth[75],
          height: '100%',
          backgroundColor: `${theme.color.border.base}`,
          opacity: 0.5
        }
      })}
    >
      <Link
        href={url}
        variant='subtle'
        rel={nofollow(urlIndexable)}
        onClick={() => trackEvent(navigateTrigger(params))}
      >
        {children}
      </Link>
    </ListItem>
  );
};

export default SegmentNavigationItem;
